module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-container",
    class: {
      'form-container--half': _vm.halfSize
    },
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.handleSubmit($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58ba9dfb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/Form.vue
// module id = 1823
// module chunks = 1